import React from "react";

function NotFoundPage() {
  return <div>NotFound</div>;
}

export default NotFoundPage;
